import styled from "styled-components"
import { 
  COLOR,
  FONT_SIZE,
  Z_INDEXS
} from "../../themes"

export const Style = styled.div`
  * {
    margin: 0px;
    padding: 0px;
  }

  .multi-input {
    border: none;
    height: 30px;
    outline: none;
    font-family: NunitoRegular;
    font-size: 13px;
    padding: 5px;
  }

  .multi-area {
    border: 1px solid #E6E6F6;
    border-radius: 4px;
    padding-right: 5px;
    padding-left: 5px;
  }

  .multi-area input {
    flex: 1 1 auto;
    align-self: flex-start;
  }

  .multi-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    list-style-type: none;
    flex-wrap: wrap;
    align-items: center;
  }

  .multi-container .multi-box {
    border-radius: 5px;
    margin: 1px;
    padding: 5px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding-left: 10px;
    margin-left: 5px;
    color: #000;
    background-color: #f1f2f2;
  }

  .multi-box .close {
    background-color: #000000;
    color: #ffffff;
    width: 18px;
    height: 18px;
    display: -webkit-box;
    border-radius: 20px;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin-left: 10px;
    cursor: pointer;
  }

  .multi-result {
    width: 100%;
    max-height: 172px;
    box-shadow: 0px 4px 6px 1px ${COLOR.GRAY_5};
    background-color: #fff;
    z-index: ${Z_INDEXS.LV_1};
    overflow-y: scroll;
    position: absolute;
  }

  .result-list {
    line-height: 24px;
    height: 54px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -ms-user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    display: flex;
    align-items: center;
  }

  .result-list:hover {
    background-color: ${COLOR.GOLD_1};
    border-color: ${COLOR.GOLD_1};
    cursor: pointer;
  }

  .result-list figure {
    height: 32px;
    width: 32px;
    margin: 16px 16px;
    padding: 0;
    border-radius: 50%;
    border: 1px solid #E6E6F6;
  }
  
  .result-avatar-img {
    object-fit: contain;
    width: 100%;
    height: 100%;
    color: #E6E6F6;
    fill: #E6E6F6;
    border-radius: 80px;
  }

  .result-group {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: stretch;
    flex: 1;
    height: auto;
  }

  .result-title {
    margin: 0;
    padding: 0;
    line-height: ${FONT_SIZE.XXS};
    font-family: NunitoBold;
    font-size: ${FONT_SIZE.MN};
    color: ${COLOR.BLACK_1};
  }

  .result-description {
    margin: 0;
    padding: 0;
    line-height: 1em;
    font-family: NunitoRegular;
    font-size: ${FONT_SIZE.MMN}
  }

  .multi-select-list {
    width: 100%;
    max-height: 280px;
    overflow-x: scroll;
  }

  .select-list {
    line-height: 24px;
    height: 54px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -ms-user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    display: flex;
    align-items: center;
    flex-direction: row;
  }

  .select-list figure {
    height: 32px;
    width: 32px;
    margin: 16px 16px 16px 0px;
    padding: 0;
    border-radius: 50%;
    border: 1px solid #E6E6F6;
  }

  button.close-button {
    margin: auto 0;
    padding: 0;
    width: ${FONT_SIZE.XL};
    height: ${FONT_SIZE.XL};
    background-color: transparent;
    border: none;
    border-radius: 50%;
    outline: none;
    color: ${COLOR.GRAY_6};
    cursor: pointer;
    transition: color 80ms ease-out, background-color 80ms ease-out;
    margin-right: 15px;
  }
  button.close-button:hover {
    color: ${COLOR.BLACK_1};
  }
  button.close-button:focus {
    color: white;
    background-color: ${COLOR.GRAY_6};
  }
  button.close-button:active {
    color: white;
    background-color: ${COLOR.BLACK_1};
  }
  button.close-button > * {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 4px;
    box-sizing: border-box;
  }
`
